import { useState, useEffect } from 'react';
import { createModel } from 'hox';
import statisticsApi from '../lib/statisticsApi';

export default createModel(() => {
  const arr1 = [
    'everyoneIsWatching',
    'newArrival',
    'editorRecommendation',
    'socialSciences',
    'management',
    'novel',
    'life',
    'tool',
    'boysFavorite',
    'girlsFavorite',
    'finishedWork',
    'freebook',
    'hotRecommendation',
    'newBookExpress',
  ];
  const arr2 = ['大家都在看', '最新上架', '编辑推荐', '社科', '经管', '小说', '生活', '工具', '男生最爱', '女生最爱', '完结作品', '免费图书', '热门推荐', '新书速递'];

  const arr3 = [
    'novel',
    'management',
    'life',
    'socialSciences',
    'tool',
    'fantasyNovels',
    'swordsman',
    'urbanLife',
    'militaryHistory',
    'scienceFictionWorld',
    'officialdom',
    'sports',
    'suspenseThrillers',
    'other',
    'ancientRomance',
    'overheadCrossing',
    'youthCampus',
    'presidentRich',
    'fantasyFate',
    'danmeiTongren',
    'modernRomance',
    'other',
    'monthlyLib',
  ];
  const arr4 = [
    '小说',
    '经管',
    '生活',
    '社科',
    '工具',
    '玄幻小说',
    '武侠仙侠',
    '都市生活',
    '军事历史',
    '科幻世界',
    '官场职场',
    '网游竞技',
    '悬疑惊悚',
    '其他类别',
    '古代言情',
    '穿越架空',
    '青春校园',
    '总裁豪门',
    '幻想奇缘',
    '耽美同人',
    '现代言情',
    '其他类别',
    '包月书库',
  ];

  const [showHrefList, setShowHrefList] = useState<boolean>(false);
  const [hreList, setHrefList] = useState<{ name: string; nav_url: string }[]>([]);
  const [showSearchBox, setShowSearchBox] = useState<boolean>(false);

  useEffect(() => {
    statisticsApi.getListApi(
      (res: { name: string; nav_url: string }[]) => {
        setHrefList(old => {
          return [...old, ...res];
        });
      },
      () => {}
    );
  }, []);

  useEffect(() => {
    if (!JSON.parse(localStorage.getItem('hisList'))) {
      localStorage.setItem('hisList', JSON.stringify([]));
    }
    if (!localStorage.getItem('showWhat')) {
      localStorage.setItem('showWhat', '1');
    }
  }, []);

  function topbottom(b: number, c: number, d = false) {
    if (!showHrefList) {
      return { marginTop: `${b}px`, marginBottom: `${c}px`, transition: 'margin-top 0.3s' };
    }
    if (showHrefList) {
      const a = Math.ceil(hreList.length / 5) * 30 + b;
      return { marginTop: `${d ? a - 30 : a}px`, marginBottom: `${c}px`, transition: 'margin-top 0.3s' };
    }
  }

  function top(b: number) {
    if (!showHrefList) {
      return { marginTop: `${b}px`, transition: 'margin-top 0.3s' };
    }
    if (showHrefList) {
      const a = Math.ceil(hreList.length / 5) * 30 + b;
      return { marginTop: `${a}px`, transition: 'margin-top 0.3s' };
    }
  }

  return {
    arr1,
    arr2,
    arr3,
    arr4,
    showHrefList,
    setShowHrefList,
    hreList,
    top,
    topbottom,
    showSearchBox,
    setShowSearchBox,
  };
});
